var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/accordion-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/contentful/accordion-module.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("calculateModuleSpacing")) {
var t_4 = t_1.calculateModuleSpacing;
} else {
cb(new Error("cannot import 'calculateModuleSpacing'")); return;
}
context.setVariable("calculateModuleSpacing", t_4);
env.getTemplate("macros/contentful/render-entry.j2", false, "core/templates/contentful/accordion-module.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderEntry")) {
var t_8 = t_5.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_8);
var t_9;
t_9 = env.getFilter("trim").call(context, (lineno = 3, colno = 48, runtime.callWrap(t_4, "calculateModuleSpacing", context, [runtime.contextOrFrameLookup(context, frame, "entry"),1,1])));
frame.set("moduleSpacingClass", t_9, true);
if(frame.topLevel) {
context.setVariable("moduleSpacingClass", t_9);
}
if(frame.topLevel) {
context.addExport("moduleSpacingClass", t_9);
}
output += "\n\n";
var t_10;
t_10 = (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"showBottomBorder") == true?"c-contentful-accordion--border-bottom":"");
frame.set("borderBottomClass", t_10, true);
if(frame.topLevel) {
context.setVariable("borderBottomClass", t_10);
}
if(frame.topLevel) {
context.addExport("borderBottomClass", t_10);
}
output += "\n\n<div class=\"o-column o-extra-small--12\">\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline")) {
output += "\n        <h2 class=\"c-contentful-accordion__h2\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline"), env.opts.autoescape);
output += "</h2>\n    ";
;
}
output += "\n\n    <div class=\"o-accordion ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleSpacingClass"), env.opts.autoescape);
output += " js-accordion\" aria-multiselectable=\"true\">\n\n        <div class=\"o-accordion__tabset js-accordion-tabset ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"defaultState") != "OPEN"?"is-collapsed":""), env.opts.autoescape);
output += "\">\n\n            <a href=\"#";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" class=\"o-accordion__tab c-contentful-accordion__tab ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "borderBottomClass"), env.opts.autoescape);
output += " js-accordion-tab\"\n                aria-selected=\"true\" aria-controls=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" aria-expanded=\"true\" name=\"";
output += runtime.suppressValue(env.getFilter("lower").call(context, env.getFilter("replace").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title")," ","-")), env.opts.autoescape);
output += "\"\n                data-default-state=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"defaultState"), env.opts.autoescape);
output += "\" data-accordion-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\">\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline")) {
output += "\n                    <h3 class=\"o-accordion__label c-contentful-accordion__heading\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\n                    </h3>\n                ";
;
}
else {
output += "\n                    <h2 class=\"o-accordion__label c-contentful-accordion__heading\">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\n                    </h2>\n                ";
;
}
output += "\n\n                <span class=\"o-accordion__control c-contentful-accordion__control\" title=\"collapse\"></span>\n            </a>\n\n            <div id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" class=\"o-accordion__panel c-contentful-accordion__panel js-accordion-panel\" aria-labelledby=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" aria-hidden=\"false\">";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"components");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("entry", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += runtime.suppressValue((lineno = 35, colno = 32, runtime.callWrap(t_8, "renderEntry", context, [t_14])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/accordion-module.j2"] , dependencies)